import React from 'react';
import SearchIcon from '@mui/icons-material/Search';
import { Typography } from '@mui/material';
import { useTranslate } from 'hooks/use-translate';
import style from './index.module.scss';

/**
 * N2 (T5): the one empty state below md -- one icon, one size, one label
 * (`no-data`, "לא נמצאו נתונים להצגה"). Both grids' `DataGridEmpty` render it
 * inside their own wrapper below md (so every in-scope list and the global
 * search get it, and the wrapper's `data-grid-empty_wrap` class keeps
 * placing it); the desktop keeps the grids' own empty states and titles.
 */
export const MobileEmptyState: React.FC = () => {
  const { t } = useTranslate();
  return (
    <div className={style.root}>
      <SearchIcon className={style.icon} />
      <Typography component={'div'} className={style.text}>
        {t('no-data')}
      </Typography>
    </div>
  );
};
